import { Link, Navigate, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login, clickForgotPassword } from '../../actions/auth';
import { checkEmail } from '../../actions/user';
import { toast } from 'react-toastify';
import '../../css/onBoarding/login.css';
import '../../css/onBoarding/register.css';
import Loader from '../loader/Loader';
// import '../../css/';

// Image Imports
import color_logo from '../../img/color_logo.png';
import ecom_logo_color from '../../img/ecom_logo_color.png';
import email_icon from '../../img/email.png';
import password_icon from '../../img/password.png';
import bg_img_1 from '../../img/bg_img_1.png';

let Login = ({ login, checkEmail, isAuthenticated, clickForgotPassword }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [isNewEmail, setIsNewEmail] = useState(true);

  // Destructure formData
  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const onContinue = async () => {
    console.log('email', email);
    if (!email) {
      toast.error('Please enter an email address.');
      return;
    }

    try {
      const response = await checkEmail(email); // Pass the email to the action
      console.log('res', response);
      if (response.status === 200 && response.data.user === 1) {
        setIsNewEmail(false); // Email is new
      } else {
        setIsNewEmail(true); // Email exists
        toast.error('Email not found.');
      }
    } catch (error) {
      console.error('Error checking email:', error);
      toast.error('Failed to verify email. Please try again.');
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    login(email, password)
      .then((e) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    // console.log(formData);
    // console.log('Success');
  };

  const handleClickForgotPassword = async (e) => {
    e.preventDefault();

    // console.log('click on event');

    // Call action here
    await clickForgotPassword();
    // console.log('below action function');

    //navigate to link page
    navigate('/email-forgot-password');
    // console.log('below navigate');
  };

  // Redirect if logged in
  if (isAuthenticated) {
    // toast.success('Logged In Success');
    return <Navigate to='/overview' />;
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className='flex flex-col items-center justify-center'>
          {/* Logo Section */}
          <div className=''>
            <Link to='/overview'>
              <img
                src={ecom_logo_color}
                alt='Logo'
                className='color-logo-register w-24 h-24'
              />
            </Link>
          </div>

          {/* Heading Section */}
          <div className='text-center'>
            <h2 className='form-heading'>Welcome back</h2>
          </div>

          {/* Form Section */}
          <form className='w-80' onSubmit={(e) => onSubmit(e)} method='POST'>
            <div className=''>
              <input
                id='email-address'
                name='email'
                type='email'
                value={email}
                onChange={(e) => onChange(e)}
                autoComplete='email'
                required
                placeholder='Email'
                className='email-input-field bg-gray-50 w-full p-2'
              />
            </div>

            {!isNewEmail && (
              <div className=''>
                <input
                  id='password'
                  name='password'
                  type='password'
                  value={password}
                  onChange={(e) => onChange(e)}
                  autoComplete='current-password'
                  required
                  placeholder='Password'
                  className='login-password-input bg-gray-50 w-full p-2 mt-7'
                />
              </div>
            )}
            <div className='text-right mt-2 mb-7'>
              <Link to='/email-forgot-password' className='forgot-pass-link'>
                Forgot Password?
              </Link>
            </div>

            {!isNewEmail ? (
              <button type='submit' className='register-button w-full py-2'>
                Sign in
              </button>
            ) : (
              <button
                type='button'
                onClick={onContinue}
                className='continue-button w-full py-2'
              >
                Continue
              </button>
            )}
          </form>

          {/* Login Section */}
          <div className=''>
            <p className='already-account'>
              Don't have an account?{' '}
              <Link to='/register' className='login-link'>
                Sign Up
              </Link>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

login.PropTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  checkEmail: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  login,
  checkEmail,
  clickForgotPassword,
})(Login);
// export default Login;
